import { Box, Image, SimpleGrid, Text, useTheme } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import MenuWithDrodown from '../../components/generalCategories/menuWithDropdown/menuWithDropdown';
import SlideCarouselLittle from '../../components/carouselSlides/trends/slideCarouselLittle';
import { formatTextForCard } from '../../utils/functions';
import { useAppContext } from '../../App';
import { COURSES_TYPES } from '../../components/header/headerComps/navbar/navbar';
import CustomLoader from '../../components/loader/customLoader';
import { getAllByTableName, getCoursesInfo } from '../../utils/dataFetch';
import Fuse from 'fuse.js';


export default function GeneralCategories() {
  const {
    isMobile,
    searcherText,
    diploma,
    secretarys,
    appType,
    setAppType, // 👈 Asegurate de incluirlo
    categoryItems, 
    coursesInfo,
    modeFilter,
    selectedCategory, 
    setSelectedCategory
  } = useAppContext();
  const navigate = useNavigate();
  const { categoryName, type } = useParams();
  const [renderType, setRenderType] = useState(type);
  const [modesFooter, setModesFooter] = useState([]);
  const [coursesByType, setCoursesByType] = useState(
    appType === COURSES_TYPES.cursos? categoryItems : 
    appType === COURSES_TYPES.diploma? diploma : 
    appType === COURSES_TYPES.secretary? secretarys : []
  );
  const theme = useTheme();
  const style = styles(theme, isMobile);
  
  useEffect(() => {
  // Evitar sobrescribir si ya está seleccionado
  if (!selectedCategory && categoryItems && diploma && secretarys) {
    const list = type === COURSES_TYPES.cursos
      ? categoryItems
      : type === COURSES_TYPES.diploma
      ? diploma
      : type === COURSES_TYPES.secretary
      ? secretarys
      : [];

    const foundCategory = list.find(cat => decodeURIComponent(cat.name).toLowerCase() === decodeURIComponent(categoryName).toLowerCase());

    if (foundCategory) {
      setSelectedCategory(foundCategory);
    }
  }
}, [categoryItems, diploma, secretarys, type, categoryName, selectedCategory]);

useEffect(() => {
  if (!appType && type === COURSES_TYPES.cursos) {
    setAppType(COURSES_TYPES.cursos);
  }
}, [appType, type, setAppType]);

  const getImgResource = (categoryName) => {
    try {
      return require(`../../innerAsstes/categories/${categoryName}.png`);
    } catch (error) {
      return require(`../../innerAsstes/categories/Programación y Tecnologías de la Información.png`);
    }
  }
  
  const filterCoursesByMode = () => {    
    const resp = coursesInfo?.filter( course => {
      return course.modalidades.includes(modeFilter.modalidad === 3? 'presencial' : modeFilter.modalidad === 1? 'asincronico' : 'sincronico')
    })   
    return resp;
  }
  
  const fuseOptions = {
  keys: [
    { name: 'NombreCurso', weight: 0.5 },
    { name: 'Descripcion', weight: 0.3 },
    { name: 'palabras_clave', weight: 0.2 }
  ],
  includeScore: true,
  threshold: 0.4, // podés ajustar según lo permisiva que querés la búsqueda
  ignoreLocation: true,
};

const coursesToRender = searcherText
  ? new Fuse(coursesInfo || [], fuseOptions)
      .search(searcherText)
      .map(result => result.item)
  : modeFilter !== null
    ? filterCoursesByMode()
    : selectedCategory
      ? selectedCategory.cursos
      : [];

console.log('Resultados Fuse:', new Fuse(coursesInfo || [], fuseOptions).search(searcherText));

  
  const coursesBySelectedCategory = selectedCategory?.cursos?.map((course) => ({
    id: course.IdCurso,
    title: course.NombreCurso,
    name: course.NombreCurso,
    description: course.Descripcion,
  })) || [];

  useEffect(() => {
    setRenderType(type);    
    setCoursesByType(
      appType === COURSES_TYPES.cursos? categoryItems : 
      appType === COURSES_TYPES.diploma? diploma : 
      appType === COURSES_TYPES.secretary? secretarys : []
    )
  }, [selectedCategory, type, appType, categoryItems]);

  useEffect(() => {
    getAllByTableName('modalidad').then(setModesFooter)
  }, []) 
  
  if (!coursesByType) return (
    <CustomLoader customStyles={{
      text:{
        color: 'blue'
      }
    }} />
  )
  return (
    <div style={style.container} className="quicksand-semibold">
      <div style={style.menuContainer}>
        <MenuWithDrodown
          id="categories"
          title={"CATEGORIAS"}
          items={coursesByType}
          submenuItems={coursesBySelectedCategory}
          customStyles={style.menu}
          addItemToPath={true}
          subItemPathById={true}
          subitemRedirectTo={`/formulario-inscripcion/${type}/${selectedCategory?.name}`}
          onTitleClick={() => setSelectedCategory(null)}
          setSelectedCategory={setSelectedCategory}
        />
        <MenuWithDrodown
          id={'modalidad'}
          title={"MODALIDAD"}
          items={modesFooter.map(item => ({
            name: item.NombreModalidad,
            modalidad: item.IdModalidad
          }))}
          customStyles={style.menu}
        />
        <Link
          to={"/trayectoria"}
          style={style.professionalPath}
          className="sansation-bold"
        >
          TRAYECTO PROFESIONAL
        </Link>
      </div>
      <Box pl={"4vw"} pr={"4vw"} maxWidth={isMobile? "90vw":"60vw"}>
          <Text
            padding={4}
            fontFamily={"quicksand-semibold"}
            fontSize={"1rem"}
            color={theme.color.text.quaternary}
          >
            {`Estás viendo los cursos pertenecientes a: ${type}`}
          </Text>
          <Text
            padding={4}
            fontFamily={"quicksand-semibold"}
            fontSize={"1.2rem"}
            color={theme.color.text.quaternary}
          >
          {
            searcherText ? `Búsqueda por texto: ${searcherText}` :
              selectedCategory
                ? `${renderType} ${selectedCategory?.name ? '/ ' + selectedCategory?.name : ''}`
                : "Categorías Generales"
          }
          </Text>
        {!selectedCategory?.name && !searcherText && !modeFilter? (
          <SimpleGrid columns={[1, 2, 3, 4]} spacing={isMobile? 4:6} padding={isMobile? 2:4}>
            {coursesByType?.map((category, index) => (
              <Box
                key={index}
                display={"flex"}
                flexDirection={"column"}
                maxWidth={isMobile? "100%":"30vh"}
                alignItems={"center"}
                overflow="hidden"
                boxShadow="lg"
                paddingBottom={"5%"}
                _hover={{
                  boxShadow: "xl",
                  borderColor: "rgba(120,120,120,0.5)",
                  borderWidth: "1px",
                }}
                onClick={() =>{ setSelectedCategory({...category}); navigate(`/categorias-general/Cursos/${category.name}`)}}
              >
                <Image
                  src={getImgResource(category.name)}
                  maxHeight={"20vh"}
                  maxWidth={"20vh"}
                  padding={"2%"}
                  alt={category.name}
                  width="100%"
                  height="auto"
                />
                <Text
                  fontSize="lg"
                  fontWeight="bold"
                  textAlign={"center"}
                  paddingLeft={"12%"}
                  paddingRight={"12%"}
                  color={theme.color.text.secondary}
                  fontFamily={"sansation-bold"}
                >
                  {category.name}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        ) : (
          <SimpleGrid columns={[1, 2]} spacing={isMobile? 2:8} padding={isMobile? 0:4}>
            {coursesToRender?.map((course, index) => (
              <Box
                key={index}
                display={"flex"}
                flexDirection={"column"}
                maxWidth={isMobile? "100%":'25vw'}
                alignItems={"center"}
                 // height={"40vh"}
                justifyContent={"space-between"}
                // overflow="hidden"         //
                boxShadow="lg"
                _hover={{
                  boxShadow: "xl",
                  borderColor: "rgba(120,120,120,0.5)",
                  borderWidth: "1px",
                }}
              >
                <SlideCarouselLittle
                  key={`slide-tendecia-${index}`}
                  cardType={'CURSO'}
                  cardTitle={formatTextForCard('title', course.NombreCurso)}
                  cardDescription={formatTextForCard('description',course.Descripcion)}
                  showButtonMore={false}
                  customStyles={style.card}
                  period={course.Duracion}
                  modes={course.modalidades}
                  imgSrc={getImgResource(course.category_name || categoryName || selectedCategory?.name)}
                  buttonRedirectTo={`/formulario-inscripcion/${type}/${course.category_name || categoryName || selectedCategory?.name}/${course.IdCurso}`}
                />
              </Box>
            ))}
          </SimpleGrid>
        )}
      </Box>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    display: 'flex',
    padding: '2rem',
    paddingLeft: '4vw'
  },
  menuContainer: {
    display: isMobile? 'none':'flex',
    flexDirection: 'column',
    width: isMobile? '40%':'25%',
    paddingTop: '5vh'
  },
  professionalPath:{
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    maxWidth: isMobile? '100%':'95%',
    marginTop: '3%',
    marginBottom: '3%',
    color: theme.color.text.primary,
    backgroundColor: theme.background.primary,
  },
  routerAndSearcherContainer:{
    display: "flex",
    flexDirection: isMobile? "column":"row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2vw",
    minHight: '20vh'
  },
  menu:{
    container:{
      fontFamily: 'sansation-bold'
    },
    title:{
      color: theme.color.text.tertiary,
    },
    menuItem:{
      color:  theme.color.text.secondary,
      backgroundColor: theme.background.quaternary
    },
    separator:{
      width: '100%',
    }
  },
 card:{
  container:{
    height: "100%"
  },
  titleAndImgContainer: {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.5rem",
},
  cardHeader:{
    flexDirection: isMobile? 'column': 'row',
  },
  title: {
   flex: "1 1 0", // <-- Esto permite que el título use todo el espacio disponible
  fontSize: isMobile ? "clamp(1.2rem, 5vw, 2rem)" : "clamp(1rem, 1.5vw, 1.5rem)",
  width: "100%",
  maxWidth: "100%",
  lineHeight: 1.15,
  color: theme.color.text.tertiary,
  whiteSpace: "normal",
  overflowWrap: "break-word",
  wordBreak: "break-word",
  textAlign: "center",
  margin: 0,
  padding: 0,
},
  img: isMobile
    ? { display:'none' }
    : { width: '30%' },
  cardFooter:{
    flexDirection: isMobile? 'column' : 'row',
  },
  textDiv:{
    width: isMobile? '100%' : '30%',
    maxWidth: isMobile? '100%':'40%',
    fontSize: '1rem',
    borderWidth: isMobile? 0 : 1,
  },
}
});
